import {
  ROOT_PATH,
  PAYMENT_PATH,
  PENDING_PAYMENT_PATH,
  BOOKFAIR_PATH
} from 'routes/paths'
import {
  canRenewFamilyPaying,
  checkUserHasOnGoingTestPeriod,
  shouldRedirectToPayment,
  hasPendingPayment,
  hasAccessToPlatform
} from 'utils/family-paying'
import type { LocationType } from './types'
import type { UserState } from 'utils/hooks/use-userInfo'
import { shouldRedirectToBookfair } from 'utils/family-paying/paymentStatusHelpers'

function getRedirectLocation(user: UserState, currentPath): LocationType {
  const { teacher } = user

  const isTeacherOrAdmin = teacher !== null && teacher?.id !== null

  const canDoEarlyRenewal = canRenewFamilyPaying(user)

  const userIsTestingArvore = checkUserHasOnGoingTestPeriod(user)

  // Use new payment status logic if available
  const shouldAccessPaymentPage =
    !userIsTestingArvore &&
    shouldRedirectToPayment(user) &&
    isTeacherOrAdmin === false

  const shouldNotAccessPaymentPage =
    !userIsTestingArvore &&
    !shouldAccessPaymentPage &&
    !canDoEarlyRenewal &&
    hasAccessToPlatform(user)

  const userHasPendingPaymentTransactions = hasPendingPayment(user)

  const paymentPaths = [PAYMENT_PATH, PENDING_PAYMENT_PATH]

  const needsToPayBookfair = shouldRedirectToBookfair(user)

  if (needsToPayBookfair) {
    return { pathname: BOOKFAIR_PATH }
  }

  if (shouldNotAccessPaymentPage && paymentPaths.includes(currentPath)) {
    return { pathname: ROOT_PATH }
  }

  if (
    shouldAccessPaymentPage &&
    userHasPendingPaymentTransactions &&
    currentPath !== PENDING_PAYMENT_PATH
  ) {
    return { pathname: PENDING_PAYMENT_PATH }
  }

  if (shouldAccessPaymentPage && !paymentPaths.includes(currentPath)) {
    return { pathname: PAYMENT_PATH }
  }

  return {
    pathname: ''
  }
}

export default {
  getRedirectLocation
}
